export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.settings', {
      url: 'settings',
      template: '<nets-settings></nets-settings>',
    });
};
